import { FC } from 'react';

import { professionNavigation, StudentSectionSettingTypeCodes } from 'const';
import { useAppSelector, useBrightTheme, useWidgetVisibility } from 'hooks';
import { useActiveWidget } from 'hooks';
import { WidgetContainer as Widget } from 'portfolio3/components/common/WidgetContainer';
import { WidgetContainerTitle } from 'portfolio3/components/widgetContainerRecipes';
import { emitYMEvent } from 'portfolio3/features/yandexMetrika';
import { Switcher, SwitcherButton } from 'portfolio3/ui-kit';

import { proforientationVisibilitySelectors } from '../model/selectors';
import { EventsExcursionsWidget, EventsOpenDayWidget, EventsProbesWidget } from './EventsSubWidgets';
import { WidgetNames, WidgetType } from './widgets';

const sectionTypeCode = StudentSectionSettingTypeCodes.profession;
const subsectionTypeCode = StudentSectionSettingTypeCodes.professionProforientationEvents;

const navigationData = professionNavigation.proforientationEvents;

const ProforientationEventsWidget: FC = () => {
  const isVisible = useAppSelector(proforientationVisibilitySelectors.events);

  const widgets = [
    {
      id: WidgetType.PROBES,
      isVisible: isVisible.probes,
      component: EventsProbesWidget,
    },
    {
      id: WidgetType.EXCURSIONS,
      isVisible: isVisible.excursions,
      component: EventsExcursionsWidget,
    },
    {
      id: WidgetType.OPEN_DAY,
      isVisible: isVisible.dods,
      component: EventsOpenDayWidget,
    },
  ];

  const { activeWidgetId, setActiveWidgetId, activeWidgets } = useActiveWidget(widgets);

  const isBrightTheme = useBrightTheme();
  const { isSettingsMode, isWidgetVisible, toggleElement, overlayElement } = useWidgetVisibility({
    sectionTypeCode,
    subsectionTypeCode,
  });

  const widgetTitleElement = (
    <WidgetContainerTitle title={navigationData.label} right={isSettingsMode && toggleElement} />
  );
  const switcherElement = (
    <Switcher
      value={activeWidgetId ?? undefined}
      onChange={(value: number) => {
        setActiveWidgetId(value);
        emitYMEvent({
          type: 'careerGuidanceEvents_tab_click',
          payload: {
            tab: WidgetNames[value as WidgetType.PROBES | WidgetType.EXCURSIONS | WidgetType.OPEN_DAY],
          },
        });
      }}
      useHiddenList
    >
      {activeWidgets.map(({ id }) => {
        return <SwitcherButton key={id} value={id} content={WidgetNames[id]} />;
      })}
    </Switcher>
  );

  const AcitveWidgetComponent = activeWidgets.find((widget) => widget.id === activeWidgetId)?.component;

  if (!isWidgetVisible || activeWidgets.length === 0) return null;

  return (
    <Widget containerData={navigationData} withBackground={isBrightTheme}>
      {overlayElement}
      <Widget.Header title={widgetTitleElement} options={switcherElement} />
      <Widget.Padding>{AcitveWidgetComponent && <AcitveWidgetComponent />}</Widget.Padding>
    </Widget>
  );
};

export default ProforientationEventsWidget;
